export default __webpack_public_path__ + "static/media/product1.dbda35d2.jpeg";